import { useLocation, useParams } from 'react-router-dom';
import { useApolloClient, gql } from '@apollo/client';
import React from 'react';
import { getPageType } from './page-type';

export const query = gql`
  query PageSeo($path: String) {
    page(path: $path) {
      title
      description
      canonical
      noindex
    }
  }
`;

const getPageInfo = (client, location, { id }) => {
  const { pathname, search } = location;
  const pageType = getPageType(pathname);
  const routePath = pageType == 'product' ? `/produto/${id}` : `${pathname}${search}`;

  return (
    client.readQuery({ query, variables: { path: routePath } }) ||
    client.readQuery({ query, variables: { path: pathname } })
  );
};

export const withSeo = Component => props => {
  const client = useApolloClient();
  const location = useLocation();
  const params = useParams();

  const result = getPageInfo(client, location, params);
  const seo = result?.page || {};

  return <Component {...props} seo={seo} />;
};
